define.alias("ember-power-select/components/power-select/power-select-group", "calendar/components/power-select/power-select-group");